import axios from "axios";
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { useEffect } from "react";
import { useState } from "react";

const getNotifications = async () => {
  var user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : false;

  var chats = await axios.get("notifications");
  if (chats.status == 200) {
    this.setState({
      chats: chats.data,
      loading: true,
    });
  }
};

const logout = (e) => {
  axios
    .post("logout")
    .then((re) => {
      console.log("disconnect");
    })
    .catch((erro) => {
      console.log("error");
    });
  window.localStorage.clear();
  window.location.replace(process.env.REACT_APP_BEYEGROUP);
};

export const Footer = () => {
  const [datafetch, datafetchSet] = useState([])

  useEffect(() => {
    async function fetchCategory() {
      let response = await fetch( process.env.REACT_APP_API_BEYEGROUP + '/categories')
      response = await response.json()
      datafetchSet(response)
    }

    fetchCategory()
  }, [])

  const { t, i18n } = useTranslation();

  var user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : false;

  return (
    <footer id="footer" className="footer mt-5">
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-5 col-md-12 footer-info">
            <div className=" d-flex align-items-center justify-content-center">
              <a href="/" className="">
                <img src="/img/v3.png" alt="" style={{ borderRadius : 80, height : 150 }} className="p-0 m-0" />
              </a>
            </div>
            <p className="text-white">{ t("footer.description") }</p>
            <div className="social-links d-flex mt-4">
              <a href="#" className="twitter">
                <i className="bi bi-twitter"></i>
              </a>
              <a href="https://www.facebook.com/share/1AoQCeKPdE/?mibextid=wwXIfr" className="facebook"><i className="bi bi-facebook"></i></a>
              <a href="https://www.instagram.com/b.eye.tv?igsh=MWgyaDFpcnh6Y3E4OQ==" className="instagram"><i className="bi bi-instagram"></i></a>
              <a href="https://www.tiktok.com/@b.eye.tv?_t=ZM-8wfg9Sqm7QT&_r=1" className="tiktok"><i className="bi bi-tiktok"></i></a>
              <a href="https://x.com/beye2021?s=11" className="twitter"><i className="bi bi-twitter"></i></a>
            </div>
          </div>

          <div className="col-lg-2 col-6 footer-links">
            <h4>{ t("footer.lieu")}</h4>
            <ul>
              <li>
                <a href="/#hero">{t("navbar.home")}</a>
              </li>
              <li>
                <a href="/#information">{t("navbar.information")}</a>
              </li>
              {/* <li>
                <a href="/#documentation">{t("navbar.documentation")}</a>
              </li>
              <li>
                <a href="/#about">{t("navbar.about")}</a>
              </li> */}
              <li>
                <a href="/#services">{t("navbar.service")}</a>
              </li>
              <li>
                <a href="/#portfolio">{t("navbar.blog")}</a>
              </li>
              {/* <li>
                <a href="/#recent-posts">{t("navbar.blog")}</a>
              </li> */}
              <li>
                <a href="/#contact">{t("navbar.contact")}</a>
              </li>
              {
                user && (
                  <li>
                  <a href="/login">{t("navbar.logout")}</a>
                </li>
                )
              }
            </ul>
          </div>

          <div className="col-lg-2 col-6 footer-links">

            <h4>Services</h4>
            <ul>
              {
                datafetch.length > 0 && (
                  datafetch.filter(dat => dat.parentId != null && dat.parentId == process.env.REACT_APP_ID_SERVICE).map((category) => {
                    return(<li key={category.id}><a href={"/categories/" + category.id }><i className={ category.icone + " text-white" }></i> { category.name }</a></li>)
                  })
                )
              }
            </ul>
          </div>

          <div className="col-lg-3 col-md-12 footer-contact text-center text-md-start">
            <h4>{ t("footer.contactnous") }</h4>
            <p>
            Burundi, Bujumbura-Mairie, Zone Rohero,<br /> Avenue de la Révolution N°20 A <br />
              <br />
              <strong>Phone:</strong> 
              <a className="text-white" target="_blank" href="https://wa.me/0025762503956"> <span> +257 62 503 956</span></a> , 
              <a className="text-white" target="_blank" href="https://wa.me/0025767021017"> <span> +257 67 021 017</span></a> 
              <br />
              <strong>Email:</strong> info@b-eyegroup.net
              <br />
            </p>
          </div>
        </div>
      </div>

      <div className="container mt-4">
        <div className="copyright">
          &copy; Copyright{" "}
          <strong>
            <span><span>B-</span><span>EYE  </span>  </span>
          </strong>
            All Rights Reserved
        </div>
         
      </div>
    </footer>
  );
};
